import PropTypes from 'prop-types';
import Icon from 'components/elements/icon';
import { Link } from '@evertrue/et-components';
import ContactFormatMixin from 'mixins/contact-format-mixin';

// Helper to safely extract string value from field that might be an object
const safeValue = (field) => {
  if (!field) return null;
  if (typeof field === 'string') return field;
  if (typeof field === 'object' && field.value) return String(field.value);
  return null;
};

const Career = ({ data }) => {
  const career = data || {};

  // Extract safe values for rendering
  const name = safeValue(career.name);
  const title = safeValue(career.title);
  const jobFunction = safeValue(career.function);
  const industry = safeValue(career.industry);

  if (!(name || title || jobFunction || industry)) {
    return (
      <div className="career-template">
        <Icon icon="career" className="career-template--icon" />
        <div className="career-template--data is-empty">Not provided</div>
      </div>
    );
  }

  return (
    <div className="career-template">
      <Icon icon="career" className="career-template--icon" />

      <div className="career-template--data">
        <Link
          className="career-template--name fs-exclude-data"
          href={`/company${ContactFormatMixin.company_link(null, career)}`}
          title={name}
          data-refer="person"
        >
          {name}
        </Link>

        <div className="career-template--title">
          <span className="fs-exclude-data">{title}</span>
        </div>
        <div className="career-template--function">
          <span className="fs-exclude-data">{jobFunction}</span>
        </div>

        <div>
          <Link
            className="fs-exclude-data"
            href={`/industry${ContactFormatMixin.industry_link(industry)}`}
            title={industry}
            data-refer="person"
          >
            {industry}
          </Link>
        </div>
      </div>
    </div>
  );
};

Career.propTypes = {
  data: PropTypes.object,
};

export default Career;
